import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id D28EF658-3CE7-4F5B-99B3-50F60F5B0BA0
 * name format-color-text
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-color-text.svg
 * tags
 * - Text / Content / Format 
 * - Color 
 */
export const FormatColorTextIcon = createSvgIcon(<><path d="M9.62,12L12,5.67L14.37,12M11,3L5.5,17H7.75L8.87,14H15.12L16.25,17H18.5L13,3H11Z" /></>, 'FormatColorTextIcon');
export default FormatColorTextIcon